import PropTypes from 'prop-types';
import React from 'react';
import Classnames from 'classnames';

require('./style.scss');

const BaseButton = (props) => {
  const elementProps = {
    className: Classnames(
      'button',
      props.className,
      {
        'button-sm': props.small,
        'button-lg': props.large,
        'line-button': props.outline,
        'full-width': props.fullWidth,
        primary: props.primary,
        disabled: props.disabled,
      }),
    onClick: props.disabled ? null : props.onClick,
    style: {
      // Background color is allowed only for solid buttons.
      backgroundColor: !props.outline ? props.backgroundColor : null,

      // Border color is allowed only for line buttons.
      borderColor: props.outline ? props.borderColor : null,
      color: props.color,
    },
    disabled: props.disabled,
  };

  if (props.newWindow) {
    elementProps.rel = 'noopener noreferrer';
    elementProps.target = '_blank';
  }

  const elementChildren = (
    <span>
      {props.leftIcon}
      {props.leftIcon ? ' ' : null}
      <span className={Classnames({ 'hidden-xs hidden-sm': props.mobileFriendly })}>{props.label}</span>
      {props.rightIcon ? ' ' : null}
      {props.rightIcon}
    </span>);

  return props.link ?
    <a href={props.link} {...elementProps}>{elementChildren}</a> :
    <button type="button" {...elementProps}>{elementChildren}</button>;
};

BaseButton.Link = props =>
  <button
    className="link-button"
    type="button"
    onClick={props.onClick}
    style={{ color: props.color }}
  >
    {props.label}
  </button>;

BaseButton.Group = props =>
  <div className="button-group">{props.children}</div>;

BaseButton.propTypes = {
  backgroundColor: PropTypes.string,
  borderColor: PropTypes.string,
  className: PropTypes.string,
  color: PropTypes.string,
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  label: PropTypes.string.isRequired,
  large: PropTypes.bool,
  leftIcon: PropTypes.element,
  link: PropTypes.string,
  mobileFriendly: PropTypes.bool,
  newWindow: PropTypes.bool,
  onClick: PropTypes.func,
  outline: PropTypes.bool,
  primary: PropTypes.bool,
  rightIcon: PropTypes.element,
  small: PropTypes.bool,
};

BaseButton.defaultProps = {
  backgroundColor: null,
  borderColor: null,
  color: null,
  fullWidth: false,
  label: '',
  leftIcon: null,
  outline: false,
  rightIcon: null,
};

BaseButton.Link.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.string,
  color: PropTypes.string,
};

BaseButton.Group.propTypes = {
  children: PropTypes.node,
};

export default BaseButton;



// WEBPACK FOOTER //
// ./app/components/common/button/Button.jsx